<template>
  <div class="mb20">
    <a-input-search
      placeholder="请输入标题或内容..."
      :allowClear="true"
      style="width: 600px"
      @search="onSearch"
    />
  </div>
  <div>
    <a-popconfirm title="确定全部标记为已读?" @confirm="onRead(null)">
      <a-button type="primary" size="small" class="mr4"
        >全部已读</a-button
      ></a-popconfirm
    >
    <a-popconfirm title="确定全部删除?" @confirm="onDelete(null)">
      <a-button type="primary" size="small" class="mr4">全部删除</a-button>
    </a-popconfirm>
  </div>
  <remote-table
    ref="remoteTableRef"
    :columns="state.columns"
    :interfaceURL="state.dataUrl"
    :showSelection="false"
    :hasRefresh="false"
    :hasAction="false"
    :hasReset="false"
    :pageSize="20"
    :y="state.scrollY"
    :sy="state.scrollY"
    :apiParams="state.param"
  >
    <template #action="{ record }">
      <a-button
        type="link"
        @click="onRead([record.id])"
        v-if="record.status === 0"
        >标记已读
      </a-button>
      <a-popconfirm title="确定删除?" @confirm="onDelete([record.id])">
        <a-button type="link">删除</a-button>
      </a-popconfirm>
    </template>
  </remote-table>
</template>

<script>
import { inject, onMounted, reactive, ref, nextTick, h } from 'vue'
import { delete_message, read_message } from 'server/modules/message.js'
import { message } from 'ant-design-vue'
import { debounce } from 'lodash-es'
import RemoteTable from 'components/ui/remoteTable/remoteTable.vue'

export default {
  name: 'messageList',
  components: { RemoteTable },
  setup() {
    const remoteTableRef = ref(null)
    const state = reactive({
      scrollY: 500,
      dataUrl: `${process.env.VUE_APP_MESSAGE}/user/notice/list`,
      columns: [
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
          width: 80,
          ellipsis: true,
          customRender: text => {
            if (text.record.status === 0) {
              return text.text
            } else {
              return h('span', { style: { color: '#696969' } }, text.text)
            }
          }
        },
        {
          title: '内容',
          dataIndex: 'content',
          key: 'content',
          width: 200,
          ellipsis: true,
          customRender: text => {
            if (text.record.status === 0) {
              return text.text
            } else {
              return h('span', { style: { color: '#696969' } }, text.text)
            }
          }
        },
        {
          title: '时间',
          dataIndex: 'receiveTime',
          key: 'receiveTime',
          width: 80,
          customRender: text => {
            if (text.record.status === 0) {
              return text.text
            } else {
              return h('span', { style: { color: '#696969' } }, text.text)
            }
          }
        },
        {
          title: '操作',
          dataIndex: '',
          key: 'action',
          width: 80,
          align: 'center',
          slots: { title: 'action' }
        }
      ],
      param: {
        keyword: null,
        channelType: 1
      }
    })

    const onSearch = debounce(value => {
      state.param.keyword = value
    }, 300)

    const onRead = async ids => {
      const param = ids ? { noticeIds: ids } : {}
      const { success, retInfo } = await read_message(param)
      if (!success) {
        message.error(retInfo)
      } else {
        await nextTick(() => {
          remoteTableRef.value?.refresh()
        })
      }
    }

    const onDelete = async ids => {
      const param = ids ? { noticeIds: ids } : {}
      const { success, retInfo } = await delete_message(param)
      if (!success) {
        message.error(retInfo)
      } else {
        await nextTick(() => {
          remoteTableRef.value?.refresh()
        })
      }
    }

    //组件挂载时执行
    onMounted(() => {})

    return {
      state,
      remoteTableRef,
      onSearch,
      onRead,
      onDelete
    }
  }
}
</script>

<style scoped></style>
